import { render, staticRenderFns } from "./alternative-calories.vue?vue&type=template&id=529ed17c"
import script from "./alternative-calories.vue?vue&type=script&lang=js"
export * from "./alternative-calories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports